import Swal from 'sweetalert2';

// On passe noteId et setExpenses en paramètres pour la réutilisabilité
export const handleDeleteExpense = async (expenseId, noteId, setExpenses) => {
  const confirmation = await Swal.fire({
    title: 'Êtes-vous sûr ?',
    text: "Vous ne pourrez pas annuler cette action !",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Supprimer',
    cancelButtonText: 'Annuler'
  });

  if (!confirmation.isConfirmed) {
    return;
  }

  try {
    const response = await fetch(`/api/delete-expense/${expenseId}`, {
      method: 'DELETE',
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la suppression de la dépense');
    }

    // Recharger les dépenses après suppression
    const expensesResponse = await fetch(`/api/get-expenses/${noteId}`, {
      method: 'GET',
      credentials: 'include'
    });

    if (!expensesResponse.ok) {
      throw new Error('Erreur lors de la récupération des dépenses');
    }

    const expensesData = await expensesResponse.json();
    setExpenses(expensesData);
  } catch (error) {
    console.error('Erreur:', error);
    Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: 'Une erreur est survenue lors de la suppression de la dépense.',
      confirmButtonText: 'OK'
    });
  }
};
